"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AccommodationPhotos = void 0;
const utils_1 = require("@leavy/utils");
const infrastructure_1 = require("../../../infrastructure");
class AccommodationPhotos extends infrastructure_1.ValueObjectBase {
    constructor() {
        super(...arguments);
        this.photos = [];
    }
    isComplete() {
        return (utils_1.Guard.isNotNullish(this.photos) && this.photos.length > 0);
    }
    toPlain() {
        return { ...this };
    }
}
exports.AccommodationPhotos = AccommodationPhotos;
//# sourceMappingURL=AccommodationPhotos.js.map